<div #window
    class="fx-cover fx-center-all modal-window-container">
    <div #windowInner class="body modal-window-inner">
        <div class="modal-window-heading">
            <h1 class="title title--lg" translate>
                SLIDES_PANEL.ADD_NEW_SLIDE
            </h1>
            <button class="nu-icon-small nu-btn-icon close-button" (click)="closeWindow()">
                <svg class="nu-icon nu-icon-small nu-ic-close">
                    <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-close"></use>
                </svg>
            </button>
        </div>
        <div class="modal-window-body">
            <div class="selection-row">
                <div class="left-section">
                    <input (click)="setOption('existing')" [checked]="option === 'existing'" class="radio-button" type="radio" id="existing" name="presentation" value="existing">
                    <label class="label" for="existing" translate>SLIDES_PANEL.ADD_TO_EXISTING_PRESENTATION</label>
                </div>
                <div [class.disable-dropdown]="option === 'create'">
                    <abs-dropdown [settings]="{ closeOnItemClicked: true, openOnHover: false, closeOnBlur: true } "
                        (changed)="selectPresentation($event)"
                        [autoPosition]="true"
                        class="dropdown-item">
                            <sidebar-dropdown-button ddbutton [items]="selectionData" [placeholderText]="'Select Presentation'"></sidebar-dropdown-button>
                            <sidebar-list-dropdown-item dditem *ngFor="let item of selectionData"
                                class="fx-margin-bottom-10"
                                [item]="item">
                            </sidebar-list-dropdown-item>
                    </abs-dropdown>
                </div>
            </div>

            <div class="selection-row">
                <div class="left-section">
                    <input class="radio-button" [checked]="option === 'create'" type="radio" id="create" name="presentation" value="create" (click)="setOption('create')">
                    <label class="label" for="create" translate>SLIDES_PANEL.CREATE_NEW_PRESENTATION</label>
                </div>
                <div>
                    <input 
                        class="name-input" 
                        [value]="presentationName" 
                        (change)="updatePresentationName($event)" 
                        type="text" 
                        [disabled]="option === 'existing'" 
                        [placeholder]="presentationName" 
                    />
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button (click)="closeWindow()" class="btn-cancel btn-medium fx-margin-right-10" translate>BUTTONS.CANCEL</button>
            <button (click)="submitForm()" class="btn-primary btn-medium" translate>BUTTONS.ADD_SLIDE</button>
        </div>
    </div>
</div>